import React, { useState, useEffect, use } from "react";
import SearchInput from "../../components/SearchInput";
import FilterSearchResults from "../../components/FilterSearchResults";
import RenderSearchResults from "../../components/RenderSearchResults";
import { useDispatch, useSelector } from "react-redux";
import { getSearchResults, resetSearchPage, getProducts, getSuggestion, resetSuggestion,resetProductList, getRealSuggestion } from "../../containers/searchLandingSlice";
import { getFacetResults, resetFacet } from "../../containers/searchLandingSlice";
import { useSearchParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCurrentLocal } from '../../utils'

export const SearchLanding = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [facetOptionResults, setFacetOptionResults] = useState([])
  const searchResultsApiResponse = useSelector((state) => state?.searchLanding?.search?.searchResults);
  const facetResults = useSelector((state) => state?.searchLanding?.filterResult?.filters?.facet_fields?.grpDocumentType);
  const productList = useSelector((state) => state?.searchLanding?.productCarousel?.products?.docs);
  const suggestion = useSelector((state) => state?.searchLanding?.suggestion);
  const suggestionLoader = useSelector((state) => state?.searchLanding?.suggestion?.isLoading);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchResults, setSearchResults] = useState([]);
  const getcurrentloc = getCurrentLocal().toLowerCase()
  const currentloc = getcurrentloc == 'en-us'? '': '/'+getcurrentloc

  let ignore = false;
  const isMobile = window.innerWidth < 1024;

  useEffect(() => {
    if (!ignore) {
      dispatch(resetSearchPage());
      const q = searchParams.get('q') ? searchParams.get('q') : '*';
      const page = searchParams.get('p') ? searchParams.get('p') : 1;
      setCurrentPage(page);
      const productListQuery = getProductListQUery(q);
      dispatch(getProducts(productListQuery));
      const searchInput = searchParams.get('q') ? searchParams.get('q') : '';
      if (searchInput.length > 1) {
        const { finalSearchListQuery } = getSearchListingQuery(searchInput,currentPage);
        const { facetSearchQuery } = getFacetQuery({ query: searchInput, docType: null });
        dispatch(getSearchResults(finalSearchListQuery));
        setSearchResults(searchResultsApiResponse?.docs);
        dispatch(getFacetResults(facetSearchQuery));
      }
      return () => {
        ignore = true;
      };
    }

  }, []);

  useEffect(() => {
    if (!searchResultsApiResponse) {
      setSearchResults([]);
    }
    else {
      setSearchResults(searchResultsApiResponse);
    }

  }, [searchResultsApiResponse]);



  const getProductListQUery = (searchQuery) => {
    const documentType = "&documentType=";
    const documentTypeParams = "products";
    let variableParams = "&locale=" + getCurrentLocal().toLowerCase() + "&fl=id,subject,title,primaryImage,description,tagLine_s,learnMoreUrl_s,host,dataSheet_s,supportPageUrl_s,url&rows=5";

    let finalProductQuery = "?q=" + searchQuery + variableParams + documentType + documentTypeParams;
    return finalProductQuery;
  }


 const getSearchListingQuery = (searchQuery, page = currentPage) => {
  const paginationCount = 5;
  const from = (page - 1) * paginationCount;
  let variableParams = `&locale=${getCurrentLocal().toLowerCase()}&fl=id,title,description,url,contentType,filterSubDocumentType&groupBy=grpDocumentType&from=${from}&rows=${paginationCount}`;
  let finalSearchListQuery = `?q=${searchQuery}${variableParams}`;
  return { finalSearchListQuery };
};


  const getFacetQuery = (queryObj) => {
    let facetSearchQueryParams = "";
    const variableParams = "&locale=" + getCurrentLocal().toLowerCase() + "&fl=id,title&groupBy=grpDocumentType&groupLimit=10&size=5";
    if (queryObj.query) {
      facetSearchQueryParams = "?q=" + queryObj.query;
    }
    if (queryObj.docType && queryObj.docType.length > 0) {
      facetSearchQueryParams = facetSearchQueryParams + "&fq=documentType:" + queryObj.docType;
    }
    const facetSearchQuery = facetSearchQueryParams + variableParams;
    return { facetSearchQuery };

  }
  const handleSearchQueryChange = (newSearchQuery) => {
    dispatch(resetSearchPage());
    dispatch(resetFacet());
    dispatch(resetProductList())
    if (newSearchQuery.length > 0) {
      setSearchParams({ q: newSearchQuery });
      const { finalSearchListQuery } = getSearchListingQuery(newSearchQuery);
      const { facetSearchQuery } = getFacetQuery({ query: newSearchQuery, docType: null });
      dispatch(getSearchResults(finalSearchListQuery));
      dispatch(getProducts(getProductListQUery(newSearchQuery)));
      dispatch(getFacetResults(facetSearchQuery));

    }
    else {
      if (!newSearchQuery || newSearchQuery.length === 0) {
        dispatch(resetSearchPage());
        // Reset the facet filters 
        dispatch(resetFacet());
        setSearchResults([]);
        dispatch(getProducts(getProductListQUery('*')));
        // Clear the search parameters
        setSearchParams();
      }
    }
  };

 const filterSelectedOptions = (newFilter) => {
  const currentSearchInput = searchParams.get('q') || '*';
  let facetTypeParams = '';
  const commaSeparatedFilter = [...newFilter].join(',');
  if (commaSeparatedFilter.length > 0 && commaSeparatedFilter !== 'All Results') {
    facetTypeParams = `&fq=documentType:${commaSeparatedFilter}`;
  }
  setCurrentPage(1);
  setSearchParams({ q: currentSearchInput, p: '1' });
  const { finalSearchListQuery } = getSearchListingQuery(currentSearchInput + facetTypeParams, 1);
  dispatch(getSearchResults(finalSearchListQuery));
};

  const sanitizeInput = (input) => {
    const cleanInput = input.replace(/<\/?[^>]+(>|$)/g, "").trim();
    const words = cleanInput.split(" ");
    const sanitizedWords = words.map((word) =>
      word.includes("-") ? `"${word}"` : word
    );
    return sanitizedWords.join(" ");
  };
  const getCustomerChannel = () => {
    // Function to get cookie value by name
    const getCookie = (name) => {
      const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
      return match ? match[2] : null;
    };
 
    // Check if channel is available in cookies
    const channelCookie = getCookie("Channel");
    return channelCookie || "B2C"; // Return the cookie value if found, else return "B2C"
  };
  const getSuggestionData = async (searchText) => {
    let payload=sanitizeInput(searchText)
    let specialCharacters = /[+\-&&||!(){}[\]^"~*?:/]/g;
    let sanitizedPayload = payload.replace(specialCharacters, "\\$&");
    let q = '?q=' + sanitizedPayload
    let channel="&channel="+getCustomerChannel()
    let variableParams = "&locale=" + getCurrentLocal().toLowerCase() + "&fl=id,url,productCategoryPagePath_s,productCategoryTitle_s,breadcrumbSubCategoryPagePath_s,breadcrumbSubCategoryTitle_s,primaryImage,title&groupBy=grpDocumentType&groupLimit=5&documentType=Products,Support%20Products,Software%20Downloads,Knowledge%20Base,Community,documents"+channel;
    dispatch(getSuggestion(q + variableParams))
    variableParams="&locale=" + getCurrentLocal().toLowerCase() + "&rows=5&documentType=products&fq=filterBy:products"+channel;
    dispatch(getRealSuggestion(q+variableParams))

  }

  const clearSuggestion = () => {
    dispatch(resetSuggestion())
  }

  const handlePageChange = async (page) => {
    console.log(facetOptionResults);
    const q = searchParams.get('q') || '*';
    await setSearchParams({ q: q, p: page });
    setCurrentPage(page);
    let selectedFacet = "";
    if(facetOptionResults?.length > 0){
      facetOptionResults.map((facet) => {
         if(facet.selected && facet.docType != "All Results"){
            selectedFacet = selectedFacet + "," + facet.docType;
         }
      })
    }
    console.log(selectedFacet);
    let { finalSearchListQuery } =  getSearchListingQuery(q, page);
    if(selectedFacet?.length > 0){
      finalSearchListQuery += `&fq=documentType:${selectedFacet}`
    }
    dispatch(getSearchResults(finalSearchListQuery));
  };

  return (
    <section className="sd-relative corpSearch">
      <div className="sd-container">
        <div className="sd-grid lg:sd-grid-cols-16 sd-grid-cols-8 lg:sd-gap-4">
          <div className="lg:sd-h-screen-minus-48 sd-flex sd-flex-col lg:sd-col-span-4 sd-col-span-8 lg:sd-border-r lg:sd--ml-4 lg:sd-sticky lg:sd-top-[48px] lg:sd-z-10 ">
            <div className="lg:sd-py-[2rem] sd-pt-[2rem] sd-pb-[1rem]  lg:sd-pl-4 sd-sdList lg:sd-border-b lg:sd-col-span-8 sd-col-span-4">
              {/* {!isMobile ? (
                <h2 className="sd-uppercase sd-titleText  sd-font-nb sd-text-[13px]">{t('backToHome')}</h2>
              ) : (
                <a href="#" className="sd-uppercase sd-titleText sd-font-nb sd-text-[13px]">home / Search
                </a>
              )} */}
              <a href={currentloc+'/'} className="sd-hidden lg:sd-block sd-uppercase sd-titleText  sd-font-nb sd-text-[13px]">{t('backToHome')}</a>

              
            </div>
            {
              <FilterSearchResults searchResults={facetResults} onFilterChange={filterSelectedOptions} isAll={true} facetOptionResults={facetOptionResults} setFacetOptionResults={setFacetOptionResults} />
            }
          </div>
          <div className="sd-gap-4 sd-col-span-8 lg:sd-col-span-12 lg:sd-col-start-5 lg:sd-pt-20 lg:sd-pt-[2rem]">
            <SearchInput onSearchQueryChange={handleSearchQueryChange} getSuggestionData={getSuggestionData}  clearSuggestion={clearSuggestion}  page={'search'}/>
            {<RenderSearchResults searchResults={searchResults} onPageChange={handlePageChange} productList={productList} currentPage={currentPage} setCurrentPage={setCurrentPage}/>}

          </div>
        </div>
      </div>
    </section>
  );
};

export default SearchLanding;